module.exports = __webpack_public_path__ + "static/media/icon-bar-bells.4528e3bf.svg";